import { NavItem } from './SidebarNav';

/**
 * Nests nav items into their parent folders based on folderPath.
 * Items with a folderPath matching the previous folder's id become subItems.
 */
export function nestItemsInFolders(navItems: NavItem[]): NavItem[] {
  return navItems.reduce<NavItem[]>((acc, curr): NavItem[] => {
    const prev = acc.at(-1);
    // if the previous item is a folder whose id matches this item's folderPath,
    // add this item to the folder's subItems array
    if (prev && prev.isFolder && prev.id && prev.id === curr.folderPath) {
      // the folder can be accessed if at least one of its children is accessible
      if (curr.canAccess) {
        prev.canAccess = true;
      }

      // children are hidden if their parent folder is hidden
      if (prev.isHidden) {
        curr.isHidden = true;
      }

      prev.subItems = [...(prev.subItems ?? []), curr];

      // folder's notificationCount is equal to the sum of its children's notification counts
      prev.notificationCount =
        (prev.notificationCount ?? 0) + (curr.notificationCount ?? 0);

      return [...acc.slice(0, -1), prev];
    }

    return [...acc, curr];
  }, []);
}
